const initialFormData = {
  filename: '',
  base64: '',
  dealerId: null,
};

export default {
  data() {
    return {
      isFormOpen: false,
      isLoadPage: false,
      actsList: [],
      formData: { ...initialFormData },
    };
  },
  computed: {
    user() {
      return this.$store.state.user;
    },
    loading() {
      return this.$store.state.loading;
    },
    cantSave() { return !this.formData?.base64; },
  },
  methods: {
    DownloadDocument(profileBonusId) {
      this.$store.dispatch('DownloadFile', {
        url: 'profiles/api/profiles/download-act',
        data: {
          profile_id: this.user.profile_id,
          profile_bonus_id: profileBonusId,
        },
        filename: `акт_${profileBonusId}_${this.user.profile_id}.pdf`,
      });
    },
    OnFormOpen(profileBonusId) {
      this.formData.profileBonusId = profileBonusId;
      this.isFormOpen = true;
    },
    PickDocument() {
      this.$refs.file.click();
    },
    OnFilePicked(e) {
      const app = this;
      const { files } = e.target;
      if (files[0] !== undefined) {
        app.formData.filename = files[0].name;
        const fr = new FileReader();
        fr.readAsDataURL(files[0]);
        fr.addEventListener('load', () => {
          app.formData.base64 = fr.result;
          app.$forceUpdate();
        });
      }
    },
    UploadDocument() {
      const app = this;
      app.$store.getters.axl.post('profiles/api/profiles/upload-act', {
        profile_id: this.user.profile_id,
        profile_bonus_id: this.formData.profileBonusId,
        documents: this.formData.base64,
      })
        .then(() => {
          app.$store.getters.ax.post('profiles/api/profiles/acts', { profile_id: app.user.profile_id })
            .then((result) => {
              app.actsList = result.data.acts;
            });
          app.isFormOpen = false;
        })
        .catch((error) => {
          app.$store.dispatch('HandleError', error);
        });
    },
  },
  mounted() {
    const app = this;
    app.$store.getters.ax.post('profiles/api/profiles/acts', { profile_id: app.user.profile_id })
      .then((result) => {
        app.actsList = result.data.acts;
      });
  },
};
